<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Room Setup'"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (errorMessage) {
      <tidy-error-message [text]="errorMessage" />
    }

    @if (loaded && unit) {

      <!-- Intro -->
      <tidy-card>
        <tidy-row class="vertical-align-center">
          <tidy-text [header]="unit.property_name + ' · ' + unit.unit" [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Split this unit into individually-leasable rooms. Shared spaces like the kitchen or living room stay common to everyone. Rent and rates are set separately from listings and leases.'" />
        </tidy-row>
      </tidy-card>

      <!-- Occupancy classification -->
      <tidy-row><tidy-text [title]="'Occupancy classification'" /></tidy-row>
      <tidy-card [formGroup]="classificationForm">
        <tidy-radio-button
          formControlName="classification"
          [form]="classificationForm.controls.classification"
          [items]="classificationItems" />
        @if (classificationForm.controls.classification.value === 'rooming_house') {
          <tidy-row>
            <tidy-text
              [helper]="'Rooming house adds a compliance checklist (license, inspections, egress, detectors) and requires screening every member on every move-in.'" />
          </tidy-row>
        }
      </tidy-card>

      <!-- Rooms editor -->
      <tidy-row>
        <tidy-text [title]="'Rooms'" />
      </tidy-row>
      @for (room of rooms.controls; track $index; let i = $index) {
        <tidy-card [formGroup]="room">
          <tidy-row [alignLastItemRight]="true">
            <tidy-text [body]="'Room ' + (i + 1)" [translate]="false" />
            @if (rooms.length > 1) {
              <tidy-text [actionBody]="'Remove'" (action)="removeRoom(i)" class="link red" />
            }
          </tidy-row>
          <tidy-input
            [label]="'Room name'"
            formControlName="name"
            [form]="room.controls.name"
            [icon]="'assets/svg/bed-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a room name'" />
        </tidy-card>
      }
      <tidy-row>
        <tidy-text [actionBody]="'+ Add Room'" (action)="addRoom()" class="white-link" />
      </tidy-row>

      <!-- Common areas -->
      <tidy-row>
        <tidy-text [title]="'Common areas'" />
      </tidy-row>
      @if (commonAreas.length === 0) {
        <tidy-alert><tidy-row><tidy-text [body]="'No shared spaces added yet.'" /></tidy-row></tidy-alert>
      }
      @for (common of commonAreas.controls; track $index; let i = $index) {
        <tidy-card [formGroup]="common">
          <tidy-row [alignLastItemRight]="true">
            <tidy-input
              [label]="'Shared space name'"
              formControlName="name"
              [form]="common.controls.name"
              [icon]="'assets/svg/home-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a name'" />
          </tidy-row>
          <tidy-row>
            <tidy-text [actionBody]="'Remove'" (action)="removeCommonArea(i)" class="link red" />
          </tidy-row>
        </tidy-card>
      }
      <tidy-row>
        <tidy-text [actionBody]="'+ Add Common Area'" (action)="addCommonArea()" class="white-link" />
      </tidy-row>

      <tidy-row class="extra-top-padding">
        <tidy-button
          [text]="isEditing ? 'Save Rooms' : 'Convert to By-The-Room'"
          [action]="save"
          [disabled]="saving"
          class="primary" />
      </tidy-row>

      @if (isEditing) {
        <tidy-row>
          <tidy-text [actionBody]="'Convert back to entire unit'" (action)="revertToEntire()" class="link" />
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
